var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"no-uppercase",attrs:{"color":"red","text":"","small":""},on:{"click":_vm.clearFilter}},on),[_vm._v("clear filters")])]}}])},[_c('span',[_vm._v("Press to clear filters")])])}
var staticRenderFns = []

export { render, staticRenderFns }